<h1 class="text-center" [innerHTML]="textkeyPrefix + '.verbrauchsdaten.ausstieg.headline' | translate"></h1>
<div class="grid-x grid-margin-x ausstieg">
  <div class="cell small-12 medium-3">
    <app-advisor-image path="/wwc/wwc-ausstieg.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-9 large-8">
    <p [innerHTML]="(textkeyPrefix + '.verbrauchsdaten.ausstieg') | translate"></p>
    <div class="callout" >
      <p [innerHTML]="(textkeyPrefix + '.verbrauchsdaten.ausstieg.' + case) | translate"></p>
      <p [innerHTML]="(textkeyPrefix + '.verbrauchsdaten.ausstieg.text') | translate"></p>
      <div class="text-center">
        <a role="button" class="button primary inline-arrow-right" [href]="url" target="_blank" [innerHTML]="(textkeyPrefix + '.verbrauchsdaten.ausstieg.button') | translate: {url: url} "></a>
      </div>
    </div>
  </div>
</div>

<app-step-buttons [previousLink]="lastStep" [nextLink]="null" [nextSubmit]="false" mediumWidthRight="9" mediumOffset="3" leftAlignSize="medium" largeOffset="3" largeWidthRight="8" [nextText]="textkeyPrefix + '.verbrauchsanalyse.start.next'"></app-step-buttons>

